import { armorTypeIcons, armorTypes } from 'app/frontend/types/custom/ArmorType'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { CharacterClassIcon } from 'app/frontend/base/components'
import { CharacterClass } from 'app/frontend/types/custom'
import StatTable from './StatTable'
import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'

const ArmorTypes = ({ className }: { className?: string }) => {
  return (
    <StatTable<CharacterClass[]>
      className={className}
      title='Armor type'
      subject={armorTypes}
      memberFilterFn={(member, classes) =>
        classes.includes(member.characterReference.characterClass)
      }
      valueFn={(armorType, classes) => (
        <Tooltip>
          <TooltipTrigger>
            <span className='flex items-center gap-1.5'>
              <BlizzardIcon iconName={armorTypeIcons[armorType]} size='small' />
              {armorType}
            </span>
          </TooltipTrigger>
          <TooltipContent className='flex gap-2'>
            {classes.map((c) => (
              <CharacterClassIcon key={c} characterClass={c} size='medium' />
            ))}
          </TooltipContent>
        </Tooltip>
      )}
    />
  )
}

export default ArmorTypes
